/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * Contract Management API
 * API for Contract management UI.
 * OpenAPI spec version: 1.0.0-Draft
 */
import * as axios from 'axios';
import type {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse
} from 'axios';

import type {
  AgreementDetails,
  AgreementId
} from '../../models';




  export const getAgreements = (axiosInstance: AxiosInstance = axios.default) => {
/**
 * Header and contracts come from the BFF's copy of Payment's agreements. The schedule and overviews are read from Payment on each call; schedule is null when Payment is unavailable.
 * @summary Gets a payment agreement with its contracts and payment schedule
 */
const getAgreement = (
    agreementId: AgreementId, options?: AxiosRequestConfig
 ): Promise<AxiosResponse<AgreementDetails>> => {
    return axiosInstance.get(
      `/agreements/${agreementId}`,options
    );
  }
/**
 * Streams the signed document from the Signing service, using the customer or dealer agreement id as the signing reference.
 * @summary Downloads the signed customer or dealer agreement
 */
const downloadAgreementDocument = (
    agreementId: AgreementId,
    party: 'customer' | 'dealer', options?: AxiosRequestConfig
 ): Promise<AxiosResponse<Blob>> => {
    return axiosInstance.get(
      `/agreements/${agreementId}/documents/${party}`,{
        responseType: 'blob',
    ...options,}
    );
  }
return {getAgreement,downloadAgreementDocument}};
export type GetAgreementResult = AxiosResponse<AgreementDetails>
export type DownloadAgreementDocumentResult = AxiosResponse<Blob>
